import { CardFacadeBase } from 'utils/facades/card-facade-base';

class RegistrationFacade extends CardFacadeBase {}

export { RegistrationFacade };
